import React from 'react';
import { Icons, SVG } from '../../../../components/atoms/SVG';

export function AccordionIcon() {
  return (
    <span className="accordion__icon">
      <SVG svgSpriteId={Icons.ARROW_DOWN} />
    </span>
  );
}
